import React from "react";
import AdminDisabledField from "features/Admin/components/AdminDisabledField";

const PretreatmentForm = ({ values }) => (
	<div>
		<AdminDisabledField title="Stabilité avant pré-traitement" value={values.pretreatment_stability} />
		<AdminDisabledField title="Note avant pré-traitement" value={values.pretreatment_note} isLongText={true} />
		<AdminDisabledField title="Délai rajout analyse (en heures)" value={values.analysis_addition_time_limit} />
		<AdminDisabledField title="Programme centrifugation" value={values.pretreatment_centrifuge_prog} />
	</div>
);

export default PretreatmentForm;
